export default {
  subscriptions_summary: (state) => state.subscriptions_summary,
  subscriptions: (state) => state.subscriptions,
  billing_history: (state) => state.billing_history,
  transactions: (state) => state.transactions,
  payment_links: (state) => state.payment_links,
};
